export const FORM_VALIDATIONS = {
	REQUIRED: "This field is required",
	WRONG_FORMAT: "Wrong format",
	SIZE: {
		EIGHT: "Must be at least 8 characters",
		CHARACTERS: "It must have uppercase, lowercase and numbers",
	}
}